<template>
  <div>
    <Navbar />
        <div class="container">


        <router-view v-slot="{ Component }">
          <transition name="fade-x" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>

        </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
  components: { Navbar, Footer }
}
</script>


<style scoped>
.fade-x-enter-from,
.fade-x-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.fade-x-enter-active,
.fade-x-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
</style>
